import { Linkedin, Mail, MapPin, Clock, ArrowRight } from "lucide-react";
import { IDENTITY } from "../data/content";
import { SectionLabel, Reveal } from "../components/ui-bits";

export default function Contact() {
  const mailto = `mailto:${IDENTITY.email}?subject=${encodeURIComponent("Contact via lucarneops.fr")}`;

  return (
    <div data-testid="page-contact" className="pt-32 pb-24">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <Reveal>
          <SectionLabel>Contact</SectionLabel>
          <h1 className="mt-6 font-heading text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight text-white leading-[1.05]">
            Parlons de votre<br />prochaine mission.
          </h1>
        </Reveal>

        <div className="mt-12 grid lg:grid-cols-2 gap-12 lg:gap-20">
          {/* Coordonnées */}
          <Reveal>
            <p className="text-slate-400 text-lg leading-relaxed">
              {IDENTITY.name}, {IDENTITY.role}. Disponible pour des missions de transition et de transformation, en France et à l'international.
            </p>

            <div className="mt-10 space-y-5">
              <a href={mailto} target="_blank" rel="noopener noreferrer" data-testid="contact-email" className="flex items-center gap-4 group">
                <span className="w-11 h-11 rounded-lg bg-blue-600/10 border border-blue-500/20 flex items-center justify-center">
                  <Mail size={18} className="text-blue-500" />
                </span>
                <span className="text-white group-hover:text-blue-400 transition-colors font-medium">{IDENTITY.email}</span>
              </a>
              <a href={IDENTITY.linkedin} target="_blank" rel="noopener noreferrer" data-testid="contact-linkedin" className="flex items-center gap-4 group">
                <span className="w-11 h-11 rounded-lg bg-blue-600/10 border border-blue-500/20 flex items-center justify-center">
                  <Linkedin size={18} className="text-blue-500" />
                </span>
                <span className="text-white group-hover:text-blue-400 transition-colors font-medium">{IDENTITY.linkedinLabel}</span>
              </a>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-6 border-t border-slate-800/60 pt-8">
              <div className="flex items-start gap-3">
                <Clock size={18} className="text-blue-500 mt-0.5" />
                <div>
                  <p className="text-white text-sm font-medium">Disponibilité rapide et adaptable</p>
                  <p className="text-slate-500 text-sm">Missions de 3 à 12 mois</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <MapPin size={18} className="text-blue-500 mt-0.5" />
                <div>
                  <p className="text-white text-sm font-medium">Mobilité nationale et internationale</p>
                  <p className="text-slate-500 text-sm">Télétravail partiel</p>
                </div>
              </div>
            </div>
            <p className="mt-8 text-xs text-slate-600">SIREN {IDENTITY.siren}</p>
          </Reveal>

          {/* CTA mailto */}
          <Reveal delay={0.1}>
            <div className="bg-gradient-to-br from-blue-600/10 to-slate-900/40 border border-blue-500/20 rounded-2xl p-8 md:p-10 h-full flex flex-col justify-center text-center">
              <div className="mx-auto w-14 h-14 rounded-xl bg-blue-600/15 border border-blue-500/25 flex items-center justify-center">
                <Mail size={26} className="text-blue-400" />
              </div>
              <h2 className="mt-6 font-heading text-2xl font-medium text-white">Un projet, une mission ?</h2>
              <p className="mt-3 text-slate-400 leading-relaxed">
                Décrivez-moi votre contexte et vos enjeux par email, je vous réponds rapidement.
              </p>
              <a
                href={mailto}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-mailto-cta"
                className="mt-8 inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-500 text-white px-7 py-4 rounded-lg font-medium transition-colors group"
              >
                Écrire à {IDENTITY.email}
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
